'use client';

import useCursorPosition from '@/client/hooks/useCursorPosition';
import useCursorImageContainer from '@/client/stores/useCursorImageContainer';
import Image from 'next/image';
import React, { Suspense, useEffect, useMemo } from 'react';

export function ImageCursorContainer() {
  const { raw } = useCursorPosition();
  const { value, setValue } = useCursorImageContainer();
  const style = useMemo(
    () =>
      ({
        left: raw.x,
        top: raw.y,
      }) satisfies React.CSSProperties,
    [raw.x, raw.y],
  );

  useEffect(() => setValue(null), [setValue]);

  return (
    value && (
      <div className="aria-hidden absolute pointer-events-none" style={style}>
        <Suspense fallback={null}>
          <Image
            fetchPriority="low"
            loading="lazy"
            src={value.src + '?width=200&height=200&quality=20&fit=cover'}
            alt={value.alt}
            style={{ width: '200px', height: '200px', objectFit: 'cover' }}
            width={value.originWidth}
            height={value.originHeight}
          />
        </Suspense>
      </div>
    )
  );
}
